import React from 'react';
import Button from '../common/Button';
import { Download } from 'lucide-react';

interface LogoControlsProps {
  onExport: (format: 'png' | 'svg') => void;
  isExporting: boolean;
}

const LogoControls: React.FC<LogoControlsProps> = ({ onExport, isExporting }) => {
  return (
    <div className="mt-6 flex justify-end space-x-4">
      <Button
        variant="secondary"
        onClick={() => onExport('svg')}
        disabled={isExporting}
        icon={Download}
      >
        {isExporting ? 'Exporting...' : 'Export SVG'}
      </Button>
      <Button
        variant="primary"
        onClick={() => onExport('png')}
        disabled={isExporting}
        icon={Download}
      >
        {isExporting ? 'Exporting...' : 'Export PNG'}
      </Button>
    </div>
  );
};

export default LogoControls;